import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import CreateMemorial from './pages/CreateMemorial';
import MemorialStyles from './pages/MemorialStyles';
import GetInTouch from './pages/GetInTouch';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';

const App: React.FC = () => {
  return (
    <Router>
      <div className="relative min-h-screen bg-[#0A0A0A]">
        {/* Grid Background with Fade */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Grid Pattern */}
          <div 
            className="absolute inset-0 opacity-[0.15]"
            style={{
              backgroundImage: `
                linear-gradient(to bottom, 
                  rgba(10, 10, 10, 0) 0%,
                  rgba(10, 10, 10, 0.8) 75%,
                  rgba(10, 10, 10, 1) 100%
                ),
                linear-gradient(to right, #333 1px, transparent 1px),
                linear-gradient(to bottom, #333 1px, transparent 1px)
              `,
              backgroundSize: '60px 60px',
              maskImage: 'linear-gradient(to bottom, black 0%, transparent 90%)'
            }}
          />
          
          {/* Additional Grid Overlay for Depth */}
          <div 
            className="absolute inset-0 opacity-[0.1]"
            style={{
              backgroundImage: `
                linear-gradient(to right, #333 1px, transparent 1px),
                linear-gradient(to bottom, #333 1px, transparent 1px)
              `,
              backgroundSize: '20px 20px',
              maskImage: 'linear-gradient(to bottom, black 0%, transparent 90%)'
            }}
          />
        </div>

        <Header />
        <main className="relative">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/create-memorial" element={<CreateMemorial />} />
              <Route path="/memorial-styles" element={<MemorialStyles />} />
              <Route path="/get-in-touch" element={<GetInTouch />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<ArticleDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
